import React from 'react';

import BrokenImage from './broken.svg';

interface ImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'alt'> {
  readonly alt: string; // make alt required
  readonly innerClassName?: string;
}

function Image({ src = BrokenImage, height = 24, width = 24, className, innerClassName, alt, ...props }: ImageProps): JSX.Element {
  const source = src || BrokenImage;

  return (
    <div className={className}>
      <img
        src={source}
        height={height}
        width={width}
        className={innerClassName}
        alt={alt}
        {...props}
        style={{
          ...(source === BrokenImage
            ? {
                padding: Math.min(Number(height), Number(width)) * 0.2,
              }
            : {}),
          ...props.style,
        }}
      />
    </div>
  );
}

export { Image };
